import React, { createContext, useContext, useEffect, useState } from "react";
import { useT } from "@/lib/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("so_lang") || "en");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.body.classList.toggle("lang-ar", lang === "ar");
    localStorage.setItem("so_lang", lang);
  }, [lang]);

  const t = useT(lang);
  const toggle = () => setLang((l) => (l === "en" ? "ar" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, t, toggle, setLang }}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
